import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureCardComponent } from './feature-card.component';
import { ButtonModule } from '../button/index';
import { TaggingModule } from '../tagging/tagging.module';


@NgModule({
  declarations: [FeatureCardComponent],
  imports: [CommonModule, ButtonModule, TaggingModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [FeatureCardComponent]
})
export class FeatureCardModule { }
